<template>
  <div id="Header">
    <div id="Title"><span>SACHIKO Analytics</span><span id="AppVersion">v{{ APP_VERSION }}</span></div>
    <div id="HeaderButtonsContainer" v-if="$CurrentUserID.value !== null && $IsSharePoint.value === false">
      <div v-if="EnvCheck === 'development'" class="Button HeaderButton" @click="ResetKeikakumeisai" title="Reset 計画明細"><img src="./assets/Icon_Cross.webp" /></div>
      <!-- <div class="Button HeaderButton" id="H_Btn_Upload" style="margin-left: auto;" page="import" @click="OpenPage" title="アップロード"><img src="./assets/Icon_Upload.svg" /></div>
      <div class="Button HeaderButton" id="H_Btn_Samples" page="samples" @click="OpenPage" title="直販出荷保留リスト">直販出</div>
      <div class="Button HeaderButton" id="H_Btn_Estimations" page="estimations" @click="OpenPage" title="見込比較">見込比較</div>
      <div class="Button HeaderButton" id="H_Btn_ReturnItems" page="molds" @click="OpenPage" title="金型"><img src="./assets/Icon_Mold.webp" /></div>
      <div class="Button HeaderButton" id="H_Btn_ReturnItems" page="returneditems" @click="OpenPage" title="返品商品"><img src="./assets/Icon_ReturnItems.svg" /></div>
      <div class="Button HeaderButton" id="H_Btn_Zaiko" page="sales" @click="OpenPage" title="在庫明細"><img src="./assets/Icon_Zaiko.svg" /></div>
      <div class="Button HeaderButton" id="H_Btn_Keikakumeisai" page="keikakumeisai" @click="OpenPage" title="計画明細"><img src="./assets/Icon_Keikaku.svg" /></div>
      <div class="Button HeaderButton" id="H_Btn_Analytics" page="analytics" @click="OpenPage" title="分析"><img src="./assets/Icon_Bunseki.svg" /></div>
      <div class="Button HeaderButton" id="H_Btn_Analytics" page="ai" @click="OpenPage" title="分析">AI</div>
      <div class="Button HeaderButton LogoutButton" id="H_Btn_Logout" @click="Logout" title="ログアウト"><img src="./assets/Icon_Logout.svg" /></div> -->
      <SideMenu class="HeaderButton" style="margin-left: auto;" :OnClick="OpenPage" :OnLogout="Logout" />
      <!-- <div class="Button HeaderButton" id="H_Btn_Analytics" page="analytics" @click="MikkiTest_GET('test')" title="test"><img src="./assets/Icon_Bunseki.svg" /></div>
      <div class="Button HeaderButton" id="H_Btn_Analytics" page="analytics" @click="MikkiTest_POST('mikki/get')" title="get table"><img src="./assets/Icon_Bunseki.svg" /></div>
      <div class="Button HeaderButton" id="H_Btn_Analytics" page="analytics" @click="MikkiTest_POST('mikki/get/tables')" title="tables"><img src="./assets/Icon_Bunseki.svg" /></div> -->
    </div>
    
  </div>
  <router-view />
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';
import SideMenu from './components/SideMenu.vue';

export default {
  name: 'App',
  metaInfo:{
    title: 'SACHIKO Analytics',
    titleTemplate: '%s | SACHIKO Analytics'
  },
  components: {
    SideMenu,
  },
  mounted(){
    const token = this.$GetToken();
    this.$CurrentUserID.value = this.$GetUserID();
    
    if (token !== '' &&
        token !== null &&
        token !== undefined)
    {
      this.saveToken(token);
    }
    else
    {
      setTimeout(()=>{
        const r = this.$router;

        if (r.currentRoute.value.path.toString() === '/verification')
        {
          const hash = new URLSearchParams(r.currentRoute.value.hash);
          if (hash.size !== 0)
          {
            return;
          }
        }

        if (r.currentRoute.value.path.toString().includes('sp_') === true)
        {
          this.$IsSharePoint.value = true;
          return;
        }

        console.log('[App.vue] return to login');
        this.$router.push('/');
      }, 100);
    }
  },
  computed:{
    ...mapGetters(['getToken']),
    EnvCheck()
    {
      console.log('environment',process.env.VUE_APP_ENV);
      return process.env.VUE_APP_ENV;
    }
  },
  methods:{
    ...mapActions(['saveToken']),
    async MikkiTest_GET(mikkiEndpoint)
    {
      // const endpoint = `localhost:3001/${mikkiEndpoint}`;
      // const endpoint = `http://15.152.35.35/proxy/api/${mikkiEndpoint}`;
      const endpoint = `https://xplusdevelopment.net/proxy/api/${mikkiEndpoint}`;
     console.log('[MikkiTest_GET]', endpoint); 
      const result = await axios.get(endpoint)
      .then (response =>{
        return response.data;
      })
      .catch(error => {
        console.log('MIKKI ERR', error);
        return null;
      });
      
      console.log('MikkiTest_GET Result', result);
    },
    async MikkiTest_POST(mikkiEndpoint)
    {
      // const endpoint = `localhost:3001/${mikkiEndpoint}`;
      // const endpoint = `http://15.152.35.35/proxy/api/${mikkiEndpoint}`;
      const endpoint = `https://xplusdevelopment.net/proxy/api/${mikkiEndpoint}`;
      console.log('[MikkiTest_POST]', endpoint); 

      const data = {
        key:'abc',
        table:'products'
      };
      
      const result = await axios.post(endpoint, data, {
        headers:
        {
            'Content-Type': 'application/json'
        }
      })
      .then (response =>{
        console.log('Mikki response', response);
        return response.data;
      })
      .catch(error => {
        console.log('MIKKI ERR', error);
        return error.response.data;
      });

      console.log('MikkiTest_POST Result', result);
    },
    Logout()
    {
      this.saveToken('');
      this.$ClearSessionInfo();
      this.$router.push('/');
    },
    OpenPage(event)
    {
      const pageName = event.target.getAttribute('page');

      const headerButtons = document.getElementsByClassName('HeaderButton');
      for(let i = 0; i < headerButtons.length; i++)
      {
        headerButtons[i].classList.remove('HeaderButtonActive');
      }

      event.target.classList.add('HeaderButtonActive');
      this.$router.push(`/${pageName}`);
    },
    // ONLY FOR DEVELOPMENT
    async ResetKeikakumeisai()
    {
      const endpoint = process.env.VUE_APP_BACKEND_URL + 'reset/keikakumeisai';
      const result = await axios.get(endpoint)
      .then (response =>{
        return response.data;
      })
      .catch(error => {
        return error;
      });
      console.log('Reset keikakumeisai result', result);
    },
  },
  data(){
    return{
      APP_VERSION: process.env.VUE_APP_VERSION,
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
  height: 100vh;
}

html, body
{
    margin: 0px;
    padding: 0px;
    height: 100%;
    width: 100%;
    overflow-x: hidden;
}

#Title
{
  place-content: center;
  display: block;
  font-size: 1.7rem;
  margin-right: 10%;
  white-space: nowrap;
}

#AppVersion
{
  margin-left: 8px;
  font-size: 0.7rem;
}

#Header
{
    height: 60px;
    min-height: 60px;
    /* background-color: #87beb1; */
    padding-left: 15px;
    padding-right: 15px;
    color: white;
    display: flex;
    background: rgb(2,89,68);
    background: linear-gradient(90deg, rgba(2,89,68,1) 20%, rgba(135,190,177,1) 40%); 
}

#HeaderButtonsContainer
{
  display: flex;
  width: 100%;
}

.HeaderButton
{
    background-color: #025944;
    margin-bottom: 10px;
    margin-top: 10px;
    /*border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;*/
    display: grid;
    justify-content: center;
    align-content: end;
    padding: 0px 10px 0px 10px;
    font-size: 1.3rem;
    font-family: 'Noto Sans', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    place-content: center;
    /* width: 128px; */
    border-radius: 10px;
    color: white;
    transition: 0.2s;
    -webkit-transition: 0.2s;
    -moz-transition: 0.2s;
    font-size: 75%;
}

.SidemenuButton
{
  span{
    color: #cdcdcd;
    transition: 0.2s;
    -webkit-transition: 0.2s;
    -moz-transition: 0.2s;
    font-size: 120%;
    cursor: pointer;
  }
}

.SidemenuButton + .SidemenuButton
{
  margin-top: 20px;
}

.SidemenuButton:hover
{
  span{
    color: #fff;
  }
}

.LogoutButton
{
  background-color: #b38181 !important;
}

.HeaderButton:hover
{
  color:#87beb1;
}

.HeaderButton img
{
  width: 28px;
  height: 28px;
  pointer-events: none;
}

.HeaderButtonActive
{
  color: white !important;
}

.HeaderButton + .HeaderButton
{
  margin-left: 15px;
}

.NoSelect
{
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

select
{
  background-color: white;
  border: 1px solid gray;
  border-radius: 5px;
  height: 28px;
}

.Disabled
{
  pointer-events: none;
  background-color: gray;
}

.Button
{
    cursor: pointer;
    place-content: center;
}

.ButtonGreen
{
  background-color: rgb(0, 169, 157);
  color: #fff;
}

.ButtonRed
{
  background-color: rgb(189, 29, 29);
  color: #fff;
}

.ButtonNormal
{
  border-radius: 50px;
  background-color: #025944;
  color: white;
  display: inline-grid;
  place-content: center;
  padding: 6px 15px;
  transition: 0.2s;
  -webkit-transition: 0.2s;
  -moz-transition: 0.2s;
}

.ButtonNormal:hover
{
  background-color: #4b7d71;
}

/* LOADING ANIMATION */
#LoadingAnimationContainer
{
  width: 100%;
  height: 100%;
  position: absolute;
  display: grid;
  justify-items: center;
  align-content: center;
  top: 0px;
  left: 0px;
  background-color: rgba(0.3,0.3,0.3,0.8);
  z-index: 99;
}

#LoadingMessage
{
  color: #5ac4bd;
  margin-top: 20px;
  font-weight: bold;
  font-size: 1.3rem;
}

.loader {
  position: relative;
  width: 100px;
  height: 100px;
}

.loader:before , .loader:after{
  content: '';
  border-radius: 50%;
  position: absolute;
  inset: 0;
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.3) inset;
}
.loader:after {
  box-shadow: 0 2px 0 #5ac4bd inset;
  animation: rotate 2s linear infinite;
}

@keyframes rotate {
  0% {  transform: rotate(0)}
  100% { transform: rotate(360deg)}
}
</style>
